import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  enableLogs: true,
  ignoreErrors: [
    "Camera access was rejected",
    "ratag is not defined",
    "Error: Aborting execution.", // AB test tooling mistake
    "Unable to open database file on disk", // google tag manager mistake
    "Key already exists in the object store", // google tag manager mistake
    "undefined is not an object (evaluating 'a.handler().then')", // sumsub inner mistake
    "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.",
    "AxiosError: Network Error", // connection error
    // todo: fix
    "Network Error",
  ],
  integrations: [
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ["skinnyrx"],
      behaviour: "drop-error-if-contains-third-party-frames",
    }),
  ],
});
